import React from 'react'
import Helmet from 'react-helmet'
import { connect } from 'react-redux'
import flatten from 'lodash.flatten'
import groupBy from 'lodash.groupby'
import mapValues from 'lodash.mapvalues'
import slugify from 'slugify'
import removeMarkdown from 'remove-markdown'

import { slugifyOptions, additionalPages, homePageId } from '../config'
import { updatePages } from '../state/actions'

import MainNavigation from '../components/Navigation/navigation'
import Header from '../components/Header/header'
import Footer from '../components/Footer/footer'
// import PrivacyBar from '../components/PrivacyBar/privacy-bar'

import { getLocalization, getOtherPageUrl } from '../localization'

import '../styles/main.scss'


class Layout extends React.Component {
  constructor(props) {
    super(props)
  }

  componentDidMount() {
    const contentfulPages = this.transformPages(this.props.data.allPages)

    this.props.updatePages({ ...contentfulPages, ...additionalPages })
  }

  getOtherLocale(lang) {
    if (lang === 'fi-FI') {
      return 'en-US'
    } else if (lang === 'en-US') {
      return 'fi-FI'
    } else {
      return lang
    }
  }

  transformPages(pages, processSubPages=false) {
    const pageEdgeValues = Object.keys(pages.edges).map(function(key) {
      return pages.edges[key]
    })

    const mappedPages = pageEdgeValues
      .filter(edge => !edge.node.subPage || processSubPages)
      .map(edge => {
        const { node_locale, title, id, subPages, hero } = edge.node
        const lang = node_locale.substring(0, 2)

        const page = {
          id,
          title,
          hero,
          path: id && id.indexOf(homePageId) === 0 ? '/' : `/${lang}/${slugify(title, slugifyOptions)}`
        }
        
        if (subPages && !processSubPages) {
          const mappedSubPages = 
            subPages.map(subPage => {
              return {
                id: subPage.id,
                title: subPage.title,
                path: subPage.id && subPage.id.indexOf(homePageId) === 0 ? '/' : `/${lang}/${slugify(subPage.title, slugifyOptions)}`,
                parent: page
              }
            })
          return [page, ... mappedSubPages ]
        } 

        return page
      })
    

    return mapValues(groupBy(flatten(mappedPages), 'path'), value => value[0])
  }

  transformNews(news) {
    const newsEdgeValues = Object.keys(news.edges).map(function(key) {
      return news.edges[key]
    })

    const mappedNews = newsEdgeValues
      .filter(edge => edge.node.heading && edge.node.body && edge.node.body.body)
      .map(edge => {
        const { node_locale, heading, id, body } = edge.node
        const lang = node_locale.substring(0, 2)

        const page = {
          id,
          heading: `${heading} – Hive Helsinki`,
          body: removeMarkdown(body.body).substring(0, 200) + '…',
          path: `/${lang}/article/${slugify(heading, slugifyOptions)}`
        }
  
        return page
      })
    

    return mapValues(groupBy(flatten(mappedNews), 'path'), value => value[0])
  } 

  getMetadata(pages) {
    const news = this.transformNews(this.props.data.news)
    const location = this.props.location.pathname.endsWith('/') ? this.props.location.pathname.slice(0, -1) : this.props.location.pathname
    const fullUrl = `https://hive.fi${location}`

    if (location in pages && pages[location].hero) {
      const page = pages[location]
      const hero = page.hero
      const description = hero.body && hero.body.body ? hero.body.body : '' 
      const title = page.title ? `${page.title} – Hive Helsinki` : 'Hive Helsinki'
      const metaTitle = page.title || 'Hive Helsinki'

      return { title, metaTitle, description, fullUrl }
    } else if (location in news) {
      const metadata = news[location]

      return { title: `${metadata.heading} – Hive Helsinki`, metaTitle: metadata.heading, description: metadata.body, fullUrl }
    }

    return { title: 'Hive Helsinki', metaTitle: 'Hive Helsinki', description: this.props.data.metaDescription.text, fullUrl}
  }

  render() {
    const {data, children, locale } = this.props
    const lang = locale ? locale.substring(0, 2) : 'en'
    const pages = this.transformPages(this.props.data.allPages, true)
    const localization = data ? getLocalization(data.globalLocalization, locale) : null
    const localizedUrl = getOtherPageUrl(lang, this.props.location.pathname, pages)
    const otherLocale = this.getOtherLocale(locale)
    const { title, metaTitle, description, fullUrl } = this.getMetadata(pages)

    return (
      <div>
        <Helmet title={ title }>
          <link rel="alternate" hreflang={otherLocale} href={localizedUrl} />
          <link rel="apple-touch-icon" href="/apple-touch-icon.png" sizes="180x180" />
          <link rel="icon" type="image/png" href="/favicon-32x32.png" sizes="32x32" />
          <link rel="icon" type="image/png" href="/favicon-16x16.png" sizes="16x16" />
          <link rel="manifest" href="/site.webmanifest" />
          <link rel="mask-icon" href="/safari-pinned-tab.svg" color="#ffffff" />
          <link rel="shortcut icon" href="/favicon.ico" />
          <meta name="msapplication-config" content="/browserconfig.xml" />
          <meta name="theme-color" content="#ffffff" />
          <meta name="msapplication-TileColor" content="#ffffff" />
          <meta name="msapplication-TileImage" content="mstile-150x150.png" />
          <meta property="twitter:card" content="summary_large_image" />
          <meta property="twitter:site" content="@HiveHelsinki" />
          <meta property="twitter:creator" content="@HiveHelsinki" />
          <meta property="twitter:image" content="https://www.hive.fi/android-chrome-120x120.jpg" />
          <meta property="twitter:title" content={ metaTitle } />
          <meta property="twitter:url" content={ fullUrl } />
          <meta property="og:title" content={ description } />
          <meta property="og:type" content="website" />
          <meta property="og:url" content={ fullUrl } />
          <meta property="og:image" content="https://www.hive.fi/android-chrome-256x256.jpg" />
          <meta property="og:description" content={ description } />
          <meta property="og:site_name" content={ metaTitle } />
          <meta name="title" content={ metaTitle } />
          <meta name="description" content={ description } />
          <meta name="author" content="Hive" />
          <meta name="copyright" content="(C) Hive" /> 
          <meta name="robots" content="index,follow" />
          <meta name="google-site-verification" content="jfqE3Xet-_xkDZBo8K8SopIlSUqkqt4tBO-mal_MMYI" />
        </Helmet>
        <Header 
          localization={localization}
          logo={data.mainNavigation.logo}
          lang={lang}
          searchData={data.searchData}
          searchLocation={this.props.location}
          applyButton={data.applyButton}>
          <MainNavigation items={data.mainNavigation.pages} lang={lang}/>
        </Header>

        <div>
          {children()}
        </div>

        <Footer 
          navigation={data.footerNavigation.pages}
          mailingListForm={ data.mailingListForm }
          lang={lang}
          localization={localization}></Footer>
      </div>
    )
  }
}

const mapStateToProps = ({ pages }) => {
  return { pages }
}

const mapDispatchToProps = dispatch => {
  return { 
    updatePages: (pages) => {
      dispatch(updatePages(pages))
    }
  }
}

const ConnectedLayout = connect(
  mapStateToProps,
  mapDispatchToProps
)(Layout)


export default ConnectedLayout



// WEBPACK FOOTER //
// ./src/layouts/index.js